import { GetAutoTestSnapshotCommand, } from "../commands/GetAutoTestSnapshotCommand";
import { WaiterState, checkExceptions, createWaiter, } from "@smithy/util-waiter";
const checkState = async (client, input) => {
    let reason;
    try {
        let result = await client.send(new GetAutoTestSnapshotCommand(input));
        reason = result;
        try {
            let returnComparator = () => {
                return result.snapshot.source.ran.buildProgram.state;
            };
            if (returnComparator() === "errored") {
                return { state: WaiterState.FAILURE, reason };
            }
        }
        catch (e) { }
        try {
            let returnComparator = () => {
                return result.snapshot.source.ran.buildProgram.state;
            };
            if (returnComparator() === "finished") {
                return { state: WaiterState.SUCCESS, reason };
            }
        }
        catch (e) { }
        try {
            let returnComparator = () => {
                return result.snapshot.source.ran.buildProgram.state;
            };
            if (returnComparator() === "waiting-to-start") {
                return { state: WaiterState.RETRY, reason };
            }
        }
        catch (e) { }
        try {
            let returnComparator = () => {
                return result.snapshot.source.ran.buildProgram.state;
            };
            if (returnComparator() === "running") {
                return { state: WaiterState.RETRY, reason };
            }
        }
        catch (e) { }
        return { state: WaiterState.SUCCESS, reason };
    }
    catch (exception) {
        reason = exception;
    }
    return { state: WaiterState.RETRY, reason };
};
/**
 * Wait until a snapshot can be published
 *  @deprecated Use waitUntilSnapshotPublishable instead. waitForSnapshotPublishable does not throw error in non-success cases.
 */
export const waitForSnapshotPublishable = async (params, input) => {
    const serviceDefaults = { minDelay: 2, maxDelay: 120 };
    return createWaiter({ ...serviceDefaults, ...params }, input, checkState);
};
/**
 * Wait until a snapshot can be published
 *  @param params - Waiter configuration options.
 *  @param input - The input to GetAutoTestSnapshotCommand for polling.
 */
export const waitUntilSnapshotPublishable = async (params, input) => {
    const serviceDefaults = { minDelay: 2, maxDelay: 120 };
    const result = await createWaiter({ ...serviceDefaults, ...params }, input, checkState);
    return checkExceptions(result);
};
